// TODO: container vs. component
// TODO: analytics
// TODO: login/logout upon expired token
// TODO: favicon
// TODO: centralizar todas as urls externas no backend (ativação, link solicitação, etc)
// TODO: configurar os testes
// TODO: 'redux-devtools-extension/logOnlyInProduction'
// TODO: "redux-persist": "^5.10.0", -> remover store.subscribe/saveStateToLocalStorage & loadStateFromLocalStorage
// TODO: https://developers.google.com/web/fundamentals/web-app-manifest/?hl=en

import { BlipChat } from 'blip-chat-widget';
import { ConnectedRouter } from 'connected-react-router';
import _ from 'lodash';
import { parse } from 'query-string';
import React, { Component, Fragment } from 'react';
import ReactGA from 'react-ga';
import { IntlProvider } from 'react-intl';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { compose } from 'redux';
import info from '../../src/commons/services/versaoBackend';
import Loading from '../commons/containers/Loading';
import AppModal from '../commons/containers/Modal';
import PrivateRoute from '../commons/containers/PrivateRoute';
import { getIntlProviderConfig } from '../commons/i18n/intl';
import { ROUTES } from '../commons/routes/routes';
import {
	actions as cfgActions,
	consts as cfgConsts,
	selectors as cfgSelectors,
	types as cfgTypes
} from '../redux/modules/configuracoes';
import { actions as flowActions, selectors as flowSelectors } from '../redux/modules/flow';
import {
	actions as userActions,
	selectors as userSelectors,
	types as userTypes
} from '../redux/modules/usuario';
import AppLayout from './AppLayout/AppLayout';
import './style.css';
import { withTheme } from 'styled-components';
import Modal from '../commons/components/Modal';
import { iniciarPesquisaSatisfacaoWidget } from '../core/utils/pesquisaSatisfacao';

const appContextPath = 'portal-servicos-frontend';

const Manutencao = Loadable({
	loader: () => import('../commons/containers/Manutencao'),
	loading: Loading
});

let bubble;

class App extends Component {
	constructor(props) {
		super(props);

		const parsed = parse(this.props.history.location.search, { decode: true });

		this.state = {
			access_token: parsed.access_token || undefined,
			exibirModal: false,
			textoAviso: '',
			fechouAviso: false
		};

		this.initialize = _.once(function() {
			const { history, analytics, chatBotBlipKey } = this.props;
			if (Boolean(analytics)) {
				// inicializando a google analytics
				ReactGA.initialize(analytics);

				// page view da url atual
				ReactGA.pageview(appContextPath + history.location.pathname);

				// ouvindo alterações de url
				history.listen(location => {
					ReactGA.pageview(appContextPath + location.pathname);
				});
			}

			if (chatBotBlipKey && chatBotBlipKey.texto && chatBotBlipKey.texto.length > 1) {
				const blipChat = new BlipChat();
				blipChat
					.withAppKey(chatBotBlipKey.texto)
					.withButton({ color: props.theme.colors.chatColor })
					.withEventHandler(BlipChat.ENTER_EVENT, () => this.hideBubble())
					// .withEventHandler(BlipChat.LEAVE_EVENT, () => this.displayBubble())
					.withoutHistory()
					.build();

				this.createBubble(blipChat);

				setTimeout(() => this.hideBubble(), 10000);
			}
		});
	}

	componentDidUpdate() {
		if (this.props.isAuthenticated) {
			iniciarPesquisaSatisfacaoWidget();
		}
	}

	createBubble(blipChat) {
		const bubbleContainer = document.createElement('div');
		bubbleContainer.id = 'bubble-container';

		bubble = document.createElement('div');
		bubble.id = 'message-bubble';
		bubble.style.backgroundColor = this.props.theme.colors.chatColor;
		bubble.onclick = function() {
			blipChat.widget._openChat();
		};

		var triangle = document.createElement('div');
		triangle.id = 'triangle';
		triangle.style.color = this.props.theme.colors.light;

		var message = document.createElement('div');
		message.id = 'message';
		message.innerHTML = 'Olá, posso ajudar?';

		bubble.appendChild(message);
		bubble.appendChild(triangle);
		bubbleContainer.appendChild(bubble);

		document.querySelector(`#blip-chat-container`).prepend(bubbleContainer);
	}

	displayBubble() {
		bubble.style.display = '';
	}

	hideBubble() {
		bubble.style.display = 'none';
	}

	shouldLogin() {
		return !this.props.isAuthenticated && this.state.access_token;
	}

	isHTML(str) {
		var a = document.createElement('div');
		a.innerHTML = str;

		for (var c = a.childNodes, i = c.length; i--; ) {
			if (c[i].nodeType === 1) return true;
		}

		return false;
	}

	isExibirModalAviso(mensagemTelaInicial) {
		return (
			mensagemTelaInicial &&
			mensagemTelaInicial.texto &&
			!this.state.exibirModal &&
			!this.state.fechouAviso
		);
	}

	componentWillUnmount() {
		if (this.shouldLogin()) {
			this.props.reset(userTypes.USER_LOGIN);
		}

		this.props.reset(cfgTypes.FIND);
	}

	async componentDidMount() {
		console.log('Portal Serviços Frotend', process.env.REACT_APP_VERSION);
		if (this.shouldLogin()) {
			this.props.forceLogin({ access_token: this.state.access_token });
		}
		try {
			const { version } = await info.consultarInfoBackend();
			console.log('Portal Serviços Backend', 'Version', version);
		} catch (error) {
			console.error('Erro ao consultar a versão do backend', error);
		}

		if (this.props.isAuthenticated) {
			iniciarPesquisaSatisfacaoWidget();
		}

		this.props.carregarConfiguracoesIniciais();
	}

	renderRoutes(stantalone) {
		return _.chain(ROUTES)
			.map(route => route)
			.filter(route => Boolean(route.isStandalone) === stantalone)
			.map((route, i) => {
				return route.isPrivate ? <PrivateRoute key={i} {...route} /> : <Route key={i} {...route} />;
			})
			.value();
	}

	render() {
		const {
			doneCfgs,
			loadingCfgs,
			sucessoCfgs,
			messages,
			history,
			mensagemTelaInicial
		} = this.props;

		if (loadingCfgs || !doneCfgs || (this.shouldLogin() && !this.props.doneLogin)) {
			// configurações e login ainda não carregaram...
			return <Loading />;
		}

		if (this.isExibirModalAviso(mensagemTelaInicial)) {
			this.setState({ exibirModal: true, textoAviso: mensagemTelaInicial.texto });
		}

		if (!sucessoCfgs) {
			return <Manutencao />;
		}

		this.initialize();
		const intlProviderProps = getIntlProviderConfig(messages);

		return (
			<IntlProvider {...intlProviderProps}>
				<ConnectedRouter history={history}>
					<Fragment>
						<Route component={AppModal} />
						<Switch>
							{this.renderRoutes(true)}
							<Switch>
								<AppLayout>
									<Switch>{this.renderRoutes(false)}</Switch>
								</AppLayout>
							</Switch>
						</Switch>
						<Modal
							size="lg"
							open={this.state.exibirModal}
							onClose={() => {
								this.setState({ exibirModal: false, fechouAviso: true });
							}}>
							{this.isHTML(this.state.textoAviso) ? (
								<div
									dangerouslySetInnerHTML={{
										__html: `${this.state.textoAviso}`
									}}
								/>
							) : (
								<p>{this.state.textoAviso}</p>
							)}
						</Modal>
					</Fragment>
				</ConnectedRouter>
			</IntlProvider>
		);
	}
}

function mapStateToProps(state) {
	return {
		loadingCfgs: flowSelectors.isLoadingByType(state, cfgTypes.CARREGAR_CONFIGURACOES_INICIAIS),
		doneCfgs: flowSelectors.isDoneByType(state, cfgTypes.CARREGAR_CONFIGURACOES_INICIAIS),
		erroCfgs: flowSelectors.getErrorByType(state, cfgTypes.CARREGAR_CONFIGURACOES_INICIAIS),
		sucessoCfgs: flowSelectors.isSuccessByType(state, cfgTypes.CARREGAR_CONFIGURACOES_INICIAIS),
		doneLogin: flowSelectors.isDoneByType(state, userTypes.USER_LOGIN),
		isAuthenticated: userSelectors.isAuthenticated(state),
		messages: cfgSelectors.getValorConfiguracao(state, cfgConsts.APPLICATION_FRONTEND_RESOURCES),
		analytics: cfgSelectors.getValorConfiguracao(state, cfgConsts.GOOGLE_ANALYTICS_KEY),
		chatBotBlipKey: cfgSelectors.getConfiguracao(state, cfgConsts.CHATBOT_BLIP_KEY),
		mensagemTelaInicial: cfgSelectors.getConfiguracao(state, cfgConsts.MENSAGEM_AVISO_TELA_INICIAL),
		state: state
	};
}

const mapDispatchToProps = {
	carregarConfiguracoesIniciais: cfgActions.carregarConfiguracoesIniciais,
	reset: flowActions.reset,
	forceLogin: userActions.forceLoginUser
};

export default compose(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)
)(withTheme(App));
